import { Link } from 'react-router-dom';

import { Localize } from 'src/app/components/Elements/Location';
import { loggedInTransferRx } from 'src/app/router/paths';
import { LOCALIZED_CITY_MONIKER } from 'src/consts';

const baseQuestions = [
  {
    question: 'How do I send a new prescription to Capsule?',
    answer: (
      <p>
        Any doctor can send prescriptions to Capsule. The next time your doctor asks, &ldquo;What&#8217;s your
        pharmacy?&rdquo; say, &ldquo;Capsule.&rdquo;
      </p>
    ),
  },
  {
    question: 'How do I transfer refills from my old pharmacy to Capsule?',
    answer: (
      <p>
        You can switch anytime. Click
        <Link className="red" to={loggedInTransferRx.toPath()}>
          {' '}
          here
        </Link>{' '}
        or text us the name of your old pharmacy and we&#8217;ll take care of the rest. We contact your old pharmacy and
        transfer your refills to Capsule. When it&#8217;s time for your next refill, we&#8217;ll text you to set up your
        payment and schedule delivery.
      </p>
    ),
  },
  {
    question: 'How does Capsule work?',
    answer: (
      <p>
        Capsule gets your new prescriptions from your doctor or your refills from your old pharmacy. We fill your
        prescriptions in our pharmacy and text you to set up free delivery. We deliver in two-hour windows everywhere in{' '}
        <Localize>{LOCALIZED_CITY_MONIKER}</Localize>.
      </p>
    ),
  },
];

const prescriptionQuestions = [
  ...baseQuestions,
  {
    question: 'What if my prescription requires a prior authorization?',
    answer: (
      <p>
        We work with your doctor and insurance company to quickly and efficiently handle your prior authorization.
        We&#8217;ll keep you updated so you know exactly how long the process will take.
      </p>
    ),
  },
  {
    question: 'Do you deliver controlled substances?',
    answer: <p>Yes. For controlled substances, we will need to verify your identification before we deliver.</p>,
  },
];

const questions = { baseQuestions, prescriptionQuestions };

export default questions;
